module.exports = __webpack_public_path__ + "img/u997.18bd76b7.png";